// ─────────────────────────────────────────────────────────────
//  Entorno de datos de ANALÍTICA (serviciosV2 / transacciones)
//  Permite alternar en runtime entre Producción y QA.
//  ⚠ SOLO afecta a serviciosV2Client. El admin/auth (axiosClient,
//     login, empresas, usuarios) SIEMPRE apunta a producción.
//  QA acepta el mismo token Bearer de producción.
// ─────────────────────────────────────────────────────────────

const PROD_SERVICES_URL = process.env.REACT_APP_SERVICES_URL
const QA_SERVICES_URL = "https://test.ls-da.com/a2/api/v1/"

export const API_ENVS = {
  prod: { key: "prod", label: "Producción", servicesUrl: PROD_SERVICES_URL },
  qa: { key: "qa", label: "QA", servicesUrl: QA_SERVICES_URL },
}

// Lee el entorno actual desde localStorage (default: prod). Por navegador.
export const getApiEnv = () => {
  try {
    return localStorage.getItem("apiEnv") === "qa" ? "qa" : "prod"
  } catch {
    return "prod"
  }
}

export const setApiEnv = (env) => {
  try {
    localStorage.setItem("apiEnv", env === "qa" ? "qa" : "prod")
  } catch {
    /* localStorage no disponible */
  }
}

export const isQaEnv = () => getApiEnv() === "qa"

export const getServicesBaseUrl = () =>
  (API_ENVS[getApiEnv()] || API_ENVS.prod).servicesUrl
